import React from "react";
import {
  Artwork as ArtworkSlider,
  Galleries as GalleriesSlider,
} from '../common/container/Slider.jsx';
import { Title } from '../common/container/Container.jsx';
import Arrows from '../common/input/Arrows.jsx';

class Auth extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const browseTitleContent = (
      <Title className="section__title--small">
        <h2>Latest Artworks</h2>
        <Arrows display="See All" link="/browse" />
      </Title>
    );

    const galleryTitleContent = (
      <Title className="section__title--small">
        <h2>Newly Added Galleries</h2>
        <Arrows display="See All" link="/galleries" />
      </Title>
    );

    return (
      <React.Fragment>
        <div className="error__cont">
          <h1 className="error__title">401 Error</h1>
          <h2 className="error__title__sub">dagnabbit</h2>

          <div className="error__text">You are not authorized to view this page.<br /><a href="/">Back to artcloud</a></div>
        </div>

        <div className="section section--browse">
          <ArtworkSlider
            id="browse"
            q={{
              limit: 30,
              offset: 0,
              type: 'Artwork'
            }}
            slideProps={{
              height: 250,
              onLikeChange: this.handleArtworkLikeChange,
            }}
            titleContent={browseTitleContent}
            url={Artcloud.url.vendor.marketplace.art.get()}
          />
        </div>

        <div className="section section--gallery">
          <GalleriesSlider
            id="galleries"
            q={{ limit: 30, offset: 0, type: 0 }}
            slideProps={{ height: 250, setWidth: false, index: 5 }}
            titleContent={galleryTitleContent}
            url={Artcloud.url.vendor.marketplace.galleries.get()}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default Auth;

// @{
//   Layout = "~/Views/Shared/Gio/_Layout.cshtml";

//   Context.Response.StatusCode = 401;
// }

// @await Html.PartialAsync("Gio/Partials/_InnerHeaderNoMarginsPartial")

// <div id="art" className="section section--browse">
//   <div className="container">
//       <div className="section__title section__title--small">
//           <h2>Latest artwork</h2>
//           <a href="@Url.Action("browse", "home")" className="btn btn--underline"><span className="btn__text">See All</span><span className="i i--darrows">>></span></a>
//       </div>

//       <div className="slider--unequal"></div>
//   </div>
// </div>
// <!-- End Section Browse -->

// <div id="galleries" className="section section--gallery">
//   <div className="container">
//       <div className="section__title section__title--small">
//           <h2>Newly added galleries</h2>
//           <a href="@Url.Action("galleries", "home")" className="btn btn--underline"><span className="btn__text">See All</span><span className="i i--darrows">>></span></a>
//       </div>

//       <div className="slider--equal galleries"></div>
//   </div>

// </div>

// @section scripts {
//   <script type="text/javascript">
//       $(document).ready(function () {
//           var uri = Artcloud.url.vendor.marketplace.art.get();
//           Artcloud.api.get(uri, {
//               offset: 0,
//               limit: 20
//           }, function (data) {
//               var slidearttemplate = Handlebars.compile(document.getElementById('slide-art-template').innerHTML);

//               var $section = $('#art');
//               Artcloud.mkt.art.template.slideart(data, slidearttemplate, $section, 255);
//           }, function () { });

//           uri = Artcloud.url.vendor.marketplace.galleries.get();
//           Artcloud.api.get(uri, {
//               offset: 0,
//               limit: 20
//           }, function (data) {
//               var $section = $('#galleries');
//               Artcloud.mkt.galleries.template.slidegallery(data, $section);
//           }, function () { });
//       });
//   </script>
// }